<div
  class="bg-img flex-1 min-h-0 relative h-full flex flex-col"
  [style.backgroundImage]="backgroundImage()"
  [style.backgroundColor]="backgroundColor()"
>
  @if (hasValidAvatar()) {
    <img
      [src]="participants()[0]!.avatar!"
      (error)="avatarBgError.set(true)"
      (load)="avatarBgError.set(false)"
      class="absolute w-0 h-0 opacity-0 pointer-events-none"
      alt=""
    />
  }
  <app-icon
    name="call/call-bg-shapes"
    [size]="971"
    [wSize]="1439"
    class="call-bg-shapes-icon"
    [class.hidden]="!shapesColor()"
    [style.color]="shapesColor() || undefined"
  />
  <div class="absolute inset-0 bg-black/30 backdrop-blur-2xl" [class.hidden]="shapesColor()"></div>
  <div class="flex justify-center flex-col items-center h-full flex-1 relative z-10">
    <div class="relative w-fit mb-8">
      <div class="custom-ring r1"></div>
      <div class="custom-ring r2"></div>
      <app-avatar
        [id]="callerId()"
        [size]="150"
        [url]="callerAvatar()"
        [name]="callerName()"
        [isDevice]="isDevice()"
        [classes]="{ avatar: 'responsive-avatar' }"
      />
    </div>

    <div class="w-full flex flex-col items-center gap-2 px-6 py-2">
      @let oaInfo = linkedOaInfo();
      @if (!oaInfo && internetSource()) {
        <div class="bg-bg-badge-info rounded-3xl flex items-center py-1.5 px-6 gap-1.5">
          <app-icon name="call/home-wifi" [size]="20" svgClass="text-text-info-primary" />
          <span class="text-text-info-primary text-sm font-medium"
            >Khách hàng Internet Viettel</span
          >
        </div>
      }
      <div class="text-2xl text-white text-center font-semibold">
        {{ callerName() }}
      </div>
      @if (!oaInfo && internetSource() && address()) {
        <div class="flex items-center gap-2">
          <app-icon name="call/location" [size]="20" svgClass="text-white" />
          <p class="owner-name !text-white !text-base !font-normal">
            {{ address() }}
          </p>
        </div>
      }
      @if (oaInfo) {
        <div class="w-full flex flex-col gap-3 items-center">
          <div class="flex items-center gap-1 py-1.5 px-4 rounded-3xl bg-btn-glass">
            <span class="owner-name !text-white !text-base !font-normal" [title]="oaInfo?.oaName">
              {{ oaInfo?.oaName }}
            </span>
            <img class="flex-shrink-0" width="16" height="16" src="assets/images/oa.svg" alt="oa" />
          </div>
          @if (oaInfo.departmentName || oaInfo.positionName) {
            <p class="owner-name !text-white !text-base !font-normal">
              {{ oaInfo.departmentName }}
              @if (oaInfo.departmentName && oaInfo.positionName) {
                -
              }
              {{ oaInfo.positionName }}
            </p>
          }
        </div>
      }
      @if (isDevice()) {
        <app-tammi-device-badge variant="dark" class="w-fit" />
      }
      <div class="text-white text-base font-normal">
        Cuộc gọi
        {{ invitation().type === CALL_TYPE.AUDIO ? 'thoại' : 'video' }}
      </div>
    </div>

    @if (!isInContact()) {
      <app-strange-number-warning
        [userID]="this.invitation().inviter || ''"
        [isCalling]="true"
      ></app-strange-number-warning>

      <div class="flex gap-1.5 mt-3 px-4 py-2 bg-bg-badge-warning rounded-3xl items-center">
        <app-icon name="call/user-strange" [size]="20" svgClass="text-text-warning-primary" />
        <span class="text-text-warning-primary text-base font-semibold"> Người lạ </span>
      </div>
    }
  </div>

  <div class="w-full px-4 pt-5 pb-8 flex justify-center items-center gap-12 z-10">
    <div class="flex flex-col items-center gap-2">
      <button
        nz-button
        nzType="default"
        class="w-16 h-16 bg-action-btn bg-[--color-border-error] border-none flex items-center justify-center rounded-full shadow active:scale-95 transition"
        (click)="handleReject()"
      >
        <app-icon name="call/x-icon" [size]="32" svgClass="text-white" />
      </button>
      <span class="text-xs sm:text-sm font-normal text-white">Từ chối</span>
    </div>
    <div class="flex flex-col items-center gap-2">
      @if (isWaiting() || isInMeeting()) {
        <img
          src="assets/icon/call/switch-call-icon.svg"
          alt="switch-call-icon"
          class="cursor-pointer w-[64px] h-[64px] active:scale-95 transition"
          (click)="handleAccept()"
        />
      } @else {
        <button
          nz-button
          nzType="default"
          class="flex items-center justify-center w-16 h-16 rounded-full !bg-call-accept shadow active:scale-95 transition"
          (click)="handleAccept()"
        >
          <app-icon
            [name]="
              invitation().type === CALL_TYPE.AUDIO
                ? 'call/start-call-icon'
                : 'meeting/camera-on-icon'
            "
            [size]="32"
            svgClass="text-white"
          />
        </button>
      }
      <span class="text-xs sm:text-sm font-normal text-white">{{
        isWaiting() || isInMeeting() ? 'Kết thúc và Trả lời' : 'Trả lời'
      }}</span>
    </div>
  </div>
</div>
